import React, { useState } from "react";
import PersonalDetails from "./PersonalDetails";
import EducationDetails from "./EducationDetails";
import ProfessionalDetails from "./ProfessionalDetails";
import Skills from "./skills";

import './EmployeeRegistrationForm.css'; // Import the custom CSS file
import Navbar from '../../components/Navbar';
import axios from "axios";
import url from "../../function/url";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
const EmployeeRegistrationForm = () => {
  const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        });
  const [fullname,setFullname] = useState("");
  const [dob,setDob] = useState("");
  const [contact,setContact] = useState("");
  const [address,setAddress] = useState("");
  const [city,setCity] = useState("");
  const [state,setState] = useState("");
  const [pincode,setPincode] = useState("");
  const [email,setEmail] = useState("");
  const [image,setImage] = useState(null);
  const navigate = useNavigate();
  function UnemployedRegsitration1(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('name',fullname);
    formdata.append('dob',dob);
    formdata.append('contact',contact);
    formdata.append('address',address);
    formdata.append('city',city);
    formdata.append('state',state);
    formdata.append('pincode',pincode);
    formdata.append('mail',email);
    if (image){
      formdata.append('image',image);
    }
    axios.post(`${url.path}/unemployed_regist1/`,formdata)
    .then((res) =>{
      if(res.data.status){
        Cookies.set("log_id",res.data.log_id);
        navigate("/education_page");
      }
    })
    .catch((err) => {
      Toast.fire({
        icon:'error',
        title:`${err}`
      })
    });

  }
  function  phonenumbervalidation(val) {
    var phonenumber = val;
    var regPhoneNumber = /^\d{10}$/; 
    if (regPhoneNumber.test(phonenumber)){
      document.getElementById('phno').style.display = 'none'; 
    } else {
      document.getElementById('phno').style.display = 'block'; 
    }
  }
  function emailvalidation(val) {
    var mail = val;
    var email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email.test(mail)) {
      document.getElementById('ema').style.display = 'none';
    } else {
      document.getElementById('ema').style.display = 'block';
    }
  }
  return (
    <div>
    <Navbar />
    <div className="form-containernew">
      <form className="personal-info-form" onSubmit={UnemployedRegsitration1}>
        <h2>Fill your Personal Information</h2>
        <label>
          Full Name
          <input type="text" placeholder="Enter your full name" value={fullname} onChange={(e) =>setFullname(e.target.value)} />
        </label>
        <label>
          Date of Birth
          <input type="date" value={dob} onChange={(e) =>setDob(e.target.value)} />
        </label>
        <label>
          Mobile
          <div className="mobile-input">
            <span className="mt-1">+91</span>
            <input type="text" placeholder="Enter mobile number" value={contact} onChange={(e) =>setContact(e.target.value)} onInput={(e) =>phonenumbervalidation(e.target.value)} />
          </div>
          <h5 style={{color:'red',display:'none'}} id="phno">Phone Number is not valid!!!</h5>
        </label>
        <label>
          Address Line 1
          <input type="text" placeholder="Enter address" value={address} onChange={(e) =>setAddress(e.target.value)} />
        </label>
        <label>
          Email
          <input type="text" placeholder="Enter Email" value={email} onChange={(e) =>setEmail(e.target.value)} onInput={(e) =>emailvalidation(e.target.value)} />
        </label>
        <h5 style={{color:'red',display:'none'}} id="ema">Email is not valid!!!</h5>
        <div className="address-row">
          <label>
            City
            <input type="text" placeholder="City" value={city} onChange={(e) =>setCity(e.target.value)} />
          </label>
          <label>
            State
            <input type="text" placeholder="State" value={state} onChange={(e) =>setState(e.target.value)} />
          </label>
          <label>
            Pin Code
            <input type="text" placeholder="Pin Code" value={pincode} onChange={(e) =>setPincode(e.target.value)} />
          </label>
        </div>
        <button type="submit" className="continue-btn"   >
          Continue →
        </button>
      </form>
      <div className="profile-image-upload">
        <h2>Add your Profile Image</h2>
        <label className="file-upload">
          <input type="file" onChange={(e) => setImage(e.target.files[0])} accept="image/*" />
          <div className="upload-box">
            <span>Choose File</span>
          </div> 
        </label>
      </div>
    </div>
    </div>
  );
};

export default EmployeeRegistrationForm;
